import { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { Button, ModalDefault, Text } from "@ficatranquilo/contabilidade.com-ui";
import useService from "@hooks/useService";
import { escapeHtml } from "@components/ow";
import { alertExcerpt } from "./alertText";

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

/** Confirmação da exclusão. O modal fica aberto se o back recusar. */
export default function DeleteAlertModal({ alert, onClose, onDeleted }) {
  const alertsService = useService("alerts");
  const [loading, setLoading] = useState(false);

  function close() {
    if (!loading) onClose();
  }

  async function confirm() {
    setLoading(true);
    try {
      await alertsService.destroy(alert.id);
      toast.success("Comunicado excluído");
      setLoading(false);
      onDeleted();
    } catch (err) {
      toast.error(err?.response?.data?.msg || "Erro ao excluir o comunicado");
      setLoading(false);
    }
  }

  return (
    <ModalDefault
      $showModal
      $setShowModal={close}
      $noClose={loading}
      $size="medium"
      $title="Excluir comunicado?"
      $contentBackground="N0"
      $footer={
        <>
          <Button $text="Cancelar" $variant="outline" $action={close} $isDisabled={loading} $noWidth />
          <Button $text="Excluir comunicado" $variant="danger" $action={confirm} $isLoading={loading} $noWidth />
        </>
      }
    >
      <Body>
        <Text
          $text="“%s”"
          $replaces={[escapeHtml(alertExcerpt(alert.text, 120))]}
          $variant="paragraph_small_medium"
          $color="N900"
          $colorEmphasis="N900"
        />
        <Text
          $text="Os colaboradores deixam de ver este comunicado. A exclusão não tem volta."
          $variant="paragraph_small_medium"
          $color="N700"
        />
      </Body>
    </ModalDefault>
  );
}
